import { useCallback, useState } from "react";

import debounce from "lodash/debounce";

function useUniqueId(): [number, () => void] {
  const [id, setId] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const generate = useCallback(
    debounce(() => {
      setId((prevId) => prevId + 1);
    }, 500),
    []
  );

  return [id, generate];
}

export default useUniqueId;
